import { CroppingSuitabilityReportModel } from "@agroyaar/sdk";
import ColumnChart from "@/shared/components/charts/ColumnChart";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import NoteBox from "@/shared/components/report-template/presentation/components/common/NoteBox";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
import {
  makeChartTemperatureRiskTitle,
  mapRiskToChartData,
} from "@/features/reports/presentation/components/cropping-pattern/utils/temperature-risk-charts";

interface TemperatureRisksProps {
  croppingSuitabilityReports: CroppingSuitabilityReportModel[];
  temperatureRisksPage: number;
  temperatureRisksChartPerPage: number;
}

const TemperatureRisks = ({
  croppingSuitabilityReports,
  temperatureRisksPage,
  temperatureRisksChartPerPage,
}: TemperatureRisksProps) => {
  return (
    <>
      {Array?.from({ length: temperatureRisksPage }, (_, index) => {
        const start = index * temperatureRisksChartPerPage;
        const pageCrops = croppingSuitabilityReports?.slice(
          start,
          start + temperatureRisksChartPerPage
        );
        return (
          <ReportTemplate serviceType="CROPPING_SUITABILITY" pageNumber={7}>
            <div className="w-full flex flex-col justify-between">
              <div className="w-full flex flex-col justify-center gap-y-5 items-start my-3">
                {index === 0 && <Title>ریسک‌های دمایی</Title>}
                <div className=" w-full flex flex-col justify-center items-center">
                  <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-y-5 my-2">
                    {pageCrops?.map((cropReport) =>
                      cropReport?.temperatureRisks?.map((risk, i) => (
                        <ColumnChart
                          key={i}
                          data={mapRiskToChartData(risk)}
                          height={300}
                          title={makeChartTemperatureRiskTitle(
                            risk,
                            cropReport.crop.persianName
                          )}
                          color={risk.type === "ABOVE" ? "red" : "blue"}
                          titleFontSize="12px"
                          labelsFontSize="10px"
                          yAxisTitle="درصد احتمال"
                          decimalNumber={0}
                        />
                      ))
                    )}
                  </div>

                  {index !== 0 && (
                    <div className=" w-full flex flex-col justify-center items-center">
                      <Title>درصد احتمال وقوع دماهای ریسک در هر ماه</Title>
                      <p className="text-[16px] !font-[B-Nazanin]">
                        بر اساس اطلاعات هواشناسی 30 سال گذشته
                      </p>
                    </div>
                  )}
                </div>
              </div>

              {index !== 0 && (
                <NoteBox>
                  براساس گزارش‌های علمی، دماهای بالاتر از مقدار تعریف شده در
                  نمودار بالا می‌تواند باعث ایجاد تنش گرمایی شود، ازطرفی دماهای
                  پایین می‌توانند منجر به تنش سرمایی در این گیاه شود.
                </NoteBox>
              )}
            </div>
          </ReportTemplate>
        );
      })}
    </>
  );
};

export default TemperatureRisks;
